export default "__VITE_ASSET__DjSoKcCL__"